import { useRouter } from "next/router";

import { ViewerPermissions } from "~/contexts/ViewerContext";
import useCurrentViewerPermissions from "~/hooks/useCurrentViewerPermissions";

type HasPermissionProps = {
  permission: ViewerPermissions;
  redirect?: string;
  billingCustomerDid?: string;
  children: React.ReactNode;
  vaspDid?: string;
};

export default function HasPermission({
  permission,
  redirect = "",
  billingCustomerDid,
  children,
  vaspDid,
}: HasPermissionProps) {
  /** Hides its children if viewer has no permission */
  const viewerPermissions = useCurrentViewerPermissions(billingCustomerDid, vaspDid);
  const router = useRouter();

  const hasPermission = viewerPermissions.includes(permission);

  if (!hasPermission && !!redirect) {
    router.replace(redirect);
    return null;
  }

  if (!hasPermission) return null;

  return <>{children}</>;
}
